/* eslint-disable no-nested-ternary */
import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { Theme } from '../../../../app/theme';
import { ActionModal } from '../../../../components/Modal';
import { TextField } from '../../../../components/TextField';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
    datePicker: {
      margin: theme.spacing(2, 0),
      '& .MuiFormControl-root': {
        width: '100%',
      },
    },
    select: {
      width: '100%',
      color: '#989898',
      margin: '10px 0',
      '& em': {
        fontStyle: 'unset !important',
      },
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 30px) scale(1)',
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
    },
    borderRight: {
      '& .MuiTab-wrapper': {
        borderRight: `1px solid ${theme.palette.grey[500]}`,
      },
    },
    borderLeft: {
      '& .MuiTab-wrapper': {
        borderLeft: `1px solid ${theme.palette.grey[500]}`,
      },
    },
    autocomplete: {
      '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
        padding: '0',
      },
    },
    streamerDescription: {
      marginTop: '12px',
      height: '103px',
    },
    copyWrapper: {
      position: 'relative',
    },
    copyButton: {
      position: 'absolute',
      right: 4,
      top: 16,
      zIndex: 1,
      '& .custom-style-icon-button': {
        border: 'none',
      },
    },
  });
};

interface IUploadVideoContentModalView extends WithStyles<typeof styles> {
  show: boolean;
  cancelVideoUpload: () => void;
  startVideoUpload: (name: string, description: string, file: File) => void;
}

const UploadVideoContentModalView: React.FC<IUploadVideoContentModalView> = ({
  classes,
  show,
  cancelVideoUpload,
  startVideoUpload,
}: IUploadVideoContentModalView) => {
  const intl = useIntl();
  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'manage_video_content',
      })}
      modalDescription={intl.formatMessage({
        id: 'manage_video_content',
      })}
      id="upload-video-modal"
      handleClose={cancelVideoUpload}
      open={show}
      actinButtonOnClick={() => {
        const fileInput = document.getElementById(
          'upload_file_name'
        ) as HTMLInputElement | null;
        const file = fileInput?.files ? fileInput.files[0] : null;
        if (file == null) return;

        const description =
          (document.getElementById(
            'upload_description'
          ) as HTMLInputElement)?.value?.trim() ?? '';
        startVideoUpload(file.name, description, file);
      }}
      actinButtonLabel={intl.formatMessage({
        id: 'add',
      })}
      actionButtonDisabled={false}
    >
      <TextField
        id="upload_file_name"
        label="File*"
        type="file"
        InputLabelProps={{ shrink: true }}
        inputProps={{
          accept: 'video/*',
          multiple: false,
        }}
      />

      <TextField
        id="upload_description"
        label="Description"
        placeholder="Optional description for the video stream to upload."
        InputLabelProps={{ shrink: true }}
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(UploadVideoContentModalView));
